import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-services-grid',
  templateUrl: './main-services-grid.component.html',
  styleUrls: ['./main-services-grid.component.scss']
})
export class MainServicesGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
